import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import TwoFactorChallenge from "@/components/app/TwoFactorChallenge";
import { toast } from "sonner";

export default function AuthCallback() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [challenge, setChallenge] = useState(null);
  const [postLoginDest, setPostLoginDest] = useState("");

  const finishLogin = (u) => {
    setUser(u);
    let dest;
    if (u.role === "admin") dest = "/admin";
    else if (u.role === "dealer") dest = "/dealer";
    else dest = postLoginDest || "/dashboard";
    navigate(dest, { replace: true, state: { user: u } });
  };

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    const intendedRole = sessionStorage.getItem("fl_intended_role") || "";
    const postLogin = sessionStorage.getItem("fl_post_login") || "";
    setPostLoginDest(postLogin);
    sessionStorage.removeItem("fl_intended_role");
    sessionStorage.removeItem("fl_post_login");
    api.post("/auth/process-session", null, {
      headers: { "X-Session-ID": sessionId, "X-Intended-Role": intendedRole },
    })
      .then((r) => {
        if (r.data?.requires_2fa) {
          setChallenge({ twofa_token: r.data.twofa_token, email: r.data.email });
          return;
        }
        finishLogin(r.data);
      })
      .catch(() => navigate("/login"));
  }, [location, navigate, setUser]);

  if (challenge) {
    return (
      <div className="mx-auto max-w-md px-4 py-16" data-testid="page-auth-callback">
        <div className="border border-border p-8">
          <TwoFactorChallenge
            twofa_token={challenge.twofa_token}
            email={challenge.email}
            onVerified={(u) => { toast.success("Signed in"); finishLogin(u); }}
            onCancel={() => navigate("/login")}
          />
        </div>
      </div>
    );
  }

  return (
    <div data-testid="page-auth-callback" className="min-h-[50vh] flex items-center justify-center">
      <div className="text-muted-foreground font-mono-data text-sm">Authenticating…</div>
    </div>
  );
}
